import {
  IFilterTableTipoEquipo,
  IFilterTipoEquipo,
  IPostCrearTipoEquipo,
  ITipoEquipoBody,
  ITipoEquipoEdit,
} from "../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";
import { fetchListVerificacion } from "../http-common";

const ListaCombo = (
  data: IFilterTipoEquipo,
  controller = new AbortController()
) => {
  return fetchListVerificacion.post("TipoEquipo/ListarCombo", data, {
    signal: controller.signal,
  });
};

const PostListarTable = (
  data: IFilterTableTipoEquipo,
  controller = new AbortController()
) => {
  return fetchListVerificacion.post("TipoEquipo/ListarTabla", data, {
    signal: controller.signal,
  });
};

const PostCrearTipoEquipo = (data: IPostCrearTipoEquipo) => {
  return fetchListVerificacion.post("TipoEquipo/CrearTipoEquipo", data);
};
const ListarAuxiliares = (request: IFilterTableTipoEquipo) => {
  return fetchListVerificacion.post(`TipoEquipo/ListarAuxiliar`, request);
};

const UpdateAuxiliar = (request: ITipoEquipoEdit) => {
  return fetchListVerificacion.put(`TipoEquipo/ActualizarAuxiliar`, request);
};

const CrearAuxiliar = (request: ITipoEquipoBody) => {
  return fetchListVerificacion.post(`TipoEquipo/CrearAuxliar`, request);
};

const EliminarTipoEquipo = (tipoEquipoId: string) => {
  return fetchListVerificacion.delete(`TipoEquipo/EliminarTipoEquipo?TipoEquipoId=${tipoEquipoId}`);
}

const TipoEquipoActualizar = (body: any) => {
  return fetchListVerificacion.put(`TipoEquipo/ActualizarNombre`, body);
};

const TipoEquipoService = {
  ListaCombo,
  PostListarTable,
  PostCrearTipoEquipo,
  TipoEquipoActualizar,
  ListarAuxiliares,UpdateAuxiliar,CrearAuxiliar,EliminarTipoEquipo
};

export default TipoEquipoService;
